













import { Vue, Component, Prop } from 'vue-property-decorator'
import BlogCard from '@/components/BlogCard.vue'
import { blogs } from '@/blogs/blogs'
import { Blog } from '../models/blog'
import { BlogCategory } from '../models/blog-category'

@Component({
  components: {
    BlogCard
  }
})
export default class Category extends Vue {
  blogCategory!: BlogCategory
  @Prop() name!: string
  @Prop() title!: string

  get blogs () {
    return blogs.filter((blog: Blog) => blog.category === this.blogCategory)
      .sort((a: Blog, b: Blog) => b.date.getTime() - a.date.getTime())
  }

  public created () {
    const name = this.name ? this.name : this.$route.params.name
    this.blogCategory = BlogCategory[name as keyof typeof BlogCategory]
  }

  data () {
    return {
      blogCategory: this.blogCategory
    }
  }
}
